export let TARGET = "" as string;
export let ENABLE_DEV_TOOLS = "" as string;
export const setTarget = (target: string) => (TARGET = target);
export const setEnableDevTools = (edt: string) => (ENABLE_DEV_TOOLS = edt);
export const UI_ROOT = import.meta.env.VITE_UI_ROOT;
export const FIELD_IFRAME_URL = import.meta.env.VITE_FIELD_IFRAME_URL;
